import {
  SET_DEVICE_TYPE,
  INIT_APP,
  AUTH_FIELD_CHANGED,
  REGISTER_USER,
  REGISTER_USER_FAIL,
  REGISTER_USER_SUCCESS,
  AUTH_UNLOAD,
  START_REDIRECT,
  TOGGLE_COPY,
  GET_TEAM_INFO,
  GET_TEAM_INFO_FAIL,
  GET_TEAM_INFO_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_SUCCESS

} from './types';



import API from './API';
const api = API.create();

export const setDeviceType = (type) =>{
  return {
    type: SET_DEVICE_TYPE,
    payload: type
  };
}


export const toggleCopy = (toggle) => {
  return {
    type: TOGGLE_COPY,
    payload: toggle
  };
};

export const initApp = (page) => {
  return (dispatch) => {
    dispatch({ type: INIT_APP, payload: true });
    switch(page){
      default:
      break;
      case "dashboard_redirect":
        dispatch({ type: START_REDIRECT, payload: '/' });
      break;
    }
  }
};
export const authFieldChanged = ({ prop, value }) => {
  return {
    type: AUTH_FIELD_CHANGED,
    payload: { prop, value }
  };
};

export const authUnload = () => {
  return {
    type: AUTH_UNLOAD
  };
};
export const registerUser = ({email, password, firstname, lastname, team_id, from_campaign, from_source, branch_id, signupKey = 'dealmachine123'}) => {
  return (dispatch) => {
    dispatch({ type: REGISTER_USER });
    api.signup(email, password, firstname, lastname, team_id, from_campaign, from_source, branch_id, signupKey)
      .then(response => {
        console.log(response);
        if(response.problem != null){
          registerUserFail(dispatch, response.problem);
        } else if(response.data.error !== false){
          registerUserFail(dispatch, response.data.error);
        } else {
          saveData(response.data.results.token);
          registerUserSuccess(dispatch, response.data.results.user, response.data.results.token);
        }
      });

  };
};

const registerUserFail = (dispatch, error) => {
  dispatch({ type: REGISTER_USER_FAIL, payload: error });
}

const registerUserSuccess = (dispatch, user, token) => {
  dispatch({
    type: REGISTER_USER_SUCCESS,
    payload: {user, token}
  });

  dispatch({ type: START_REDIRECT, payload: '/dashboard' });


}


const saveData = (token) => {
  try {
    window.localStorage.setItem('token', token);


  } catch (error) {
  }
}

export const getTeamInfo = ({id}) => {
  console.log("hey hey");
  return (dispatch) => {
    dispatch({ type: GET_TEAM_INFO });
    api.teamInfo({id})
      .then(response => {
        console.log(response);
        if(response.problem != null){
          getTeamInfoFail(dispatch, response.problem);
        } else if(response.data.error !== false){
          getTeamInfoFail(dispatch, response.data.error);
        } else {
          getTeamInfoSuccess(dispatch, response.data.results.team);
        }
      });
  };
};

const getTeamInfoFail = (dispatch, error) => {
  dispatch({ type: GET_TEAM_INFO_FAIL, payload: error });
//  dispatch({ type: START_REDIRECT, payload: 'https://dealmachine.com/' });

}

const getTeamInfoSuccess = (dispatch, team) => {
  dispatch({
    type: GET_TEAM_INFO_SUCCESS,
    payload: {team}
  });

}


export const getUser = ({token, redirect = false}) => {
  return (dispatch) => {
    dispatch({ type: LOGIN_USER });
    api.getUser(token)
      .then(response => {
        if(response.problem != null){
          dispatch({ type: START_REDIRECT, payload: '/' });
        } else if(response.data.error !== false){
          dispatch({ type: START_REDIRECT, payload: '/' });
        } else {
          loginUserSuccess(dispatch, response.data.results.user, token);
        }
      });
  };
};


const loginUserSuccess = (dispatch, user, token) => {

  dispatch({
    type: LOGIN_USER_SUCCESS,
    payload: {user, token}
  });

}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js